<template>
  <div
      @click.prevent="onClick"
      class="w-24 p-4 flex flex-col items-center justify-start gap-2 overflow-hidden"
      :class="{'bg-blue-50 rounded-md': highlighted}"
  >
    <svg xmlns="http://www.w3.org/2000/svg" class="h-18 w-18 text-brand shrink-0" fill="currentColor"
         viewBox="0 0 512 512">
      <path
          d="M64 480H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H288c-10.1 0-19.6-4.7-25.6-12.8L243.2 57.6C231.1 41.5 212.1 32 192 32H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64z"/>
    </svg>

    <div class="text-center text-sm break-words">{{ directory.name }}</div>
  </div>
</template>

<script>

export default {
  props: {
    directory: {
      type: Object,
    },
    highlighted: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      counter: 0,
      timer: null,
      doubleClickTimeout: 450
    }
  },
  computed: {},
  watch: {},
  methods: {
    previewed() {
      this.$emit('previewed', this.file)
    },
    onClick() {
      this.counter++
      this.singleClicked( false)

      if (this.counter == 1) {
        this.timer = setTimeout(() => {
          this.counter = 0
        }, this.doubleClickTimeout)

        return
      }

      if (this.counter == 2) {
        clearTimeout(this.timer)
        this.counter = 0
        this.doubleClicked()
      }

      clearTimeout(this.timer);
      this.counter = 0
    },
    singleClicked(shiftHeld) {
      this.$emit('clicked', [this.directory.id, shiftHeld])
    },
    doubleClicked() {
      this.$emit('doubleClicked', this.directory.id)
    }
  },
  mounted() {

  }
}
</script>

